module.exports = __webpack_public_path__ + "img/lgross.1a3ffa47.png";